import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class AllUserService {
    async createNewUser(data) {
        const response = await axios.post(Config.apiBasePath + '/createUser', data, {headers: authHeader()});
        // if (response.data.token) {
        /*if (response.data.status) {
        } else {
            // if (response.data.status_code == 111) {
            // } else {
            // }
        }*/
        return response;
    }

    async getInternalUsers() {
        const response = await axios.get(Config.apiBasePath + '/getInternalEmployee', {headers: authHeader()});
        // if (response.data.token) {
        // if (response.data.status) {
        // } else {
        //     // if (response.data.status_code == 111) {
        //     // } else {
        //     // }
        // }

        return response;
    }

    async updateUser(data) {
        const response = await axios.post(Config.apiBasePath + '/updateUser', data, {headers: authHeader()});
        return response;
    }

    async updateProfile(data) {
        const headers = {...authHeader(), 'Content-Type': 'multipart/form-data'};
        const response = await axios.post(Config.apiBasePath + '/updateProfile', data, {headers});
        return response;
    }

    async deleteUser(data) {
        const response = await axios.get(Config.apiBasePath + '/deleteUser/' + data, {headers: authHeader()});
        return response;
    }

    async getAllEmployee() {
        return await axios.get(Config.apiBasePath + '/getAllEmployee', {headers: authHeader()});
    }

    async updateInternalUser(data) {
        return await axios.post(Config.apiBasePath + '/updateSingleEmployee', data, {headers: authHeader()});
    }

    async refreshSingleEmployee(param) {
        return await axios.post(Config.apiBasePath + '/updateSingleInternalEmployee', null, {
            headers: authHeader(),
            params: param
        });
    }

    async getSingleEmployee(param) {
        return await axios.get(Config.apiBasePath + '/getSingleEmployee', {
            headers: authHeader(),
            params: param
        });
    }

    async updateEmployeeList() {
        return await axios.post(Config.apiBasePath + '/updateInternalEmployee', null, {
            headers: authHeader(),
        });
    }

    async updateAllEmployeePhoto(){
        return await axios.post(Config.apiBasePath + '/updateAllEmployeePhoto', null, {
            headers: authHeader(),
        });
    }
}

export default new AllUserService();
